
import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Grid } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import WhatAppMobile from "../../LandingPage/WhatAppMobile";
import { Helmet } from "react-helmet";
import Footer from "../../LandingPage/Footer";
import NavBar from "../../../Navigation/NavBar";
import headerimg from "../../../../assets/Header-img.png";
import line2 from "../../../../assets/line2.svg";
import Tutor2 from "../../../../assets/Tutor2.png";
import Pin1 from "../../../../assets/Pin1.svg";
import Pin2 from "../../../../assets/Pin2.svg";
import Pin3 from "../../../../assets/Pin3.svg";
import Leaderstyle from "../../../../assets/Leaderstyle.svg";
import Leaderstyle2 from "../../../../assets/Leaderstyle2.svg";
import Leaderstyle3 from "../../../../assets/Leaderstyle3.svg";
import Leaderstyle4 from "../../../../assets/Best tutor.svg";
import Leaderstyle5 from "../../../../assets/Convenient.svg";
import Leaderstyle6 from "../../../../assets/Affordable.svg";
import Scale from "../../../../assets/Scale.svg";
import Frame from "../../../../assets/Frame.svg";
import Step1 from "../../../../assets/Step1.svg";
import Step2 from "../../../../assets/Step2.svg";
import Step3 from "../../../../assets/Step3.svg";
import line3 from "../../../../assets/line3.svg";
import Frame24 from "../../../../assets/Frame24.svg";
import Group221 from "../../../../assets/Group221.svg";
import Globe from "../../../../assets/Globe.svg";
import NoteBook from "../../../../assets/NoteBook.svg";
import class1_6 from "../../../../assets/1-6.jpg";
import class7 from "../../../../assets/7.jpg";
import class8 from "../../../../assets/8.jpg";
import class9 from "../../../../assets/9.jpeg";
import class10 from "../../../../assets/10.jpg";
import class11 from "../../../../assets/11.jpg";
import class12 from "../../../../assets/12.jpg";
import IIT from "../../../../assets/IIT.jpeg";
import Neet from "../../../../assets/Neet.jpeg";
import NDA from "../../../../assets/NDA.jpg";
import ArrowNew from "../../../../assets/ArrowNew.svg";
import Linenew from "../../../../assets/Linenew.svg";
import QuicklinkBg from "../../../../assets/QuicklinkBG.png";
import PhoneDoodlePlus from "../../../../assets/PhoneDoodlePlus.svg";
import PhoneDoodleMultiply from "../../../../assets/PhoneDoodleMultiply.svg";
import PhoneDoodleBook from "../../../../assets/PhoneDoodleBook.svg";
import PhoneDoodleDivide from "../../../../assets/PhoneDoodleDivide.svg";
import GroupPhone from "../../../../assets/mobile-screen 2.svg";
import Frame25 from "../../../../assets/Frame25.svg";
import NotFound from "../../LandingPage/NotFound";
import Group2081 from "../../../../assets/Group2081.svg";
import Group35 from "../../../../assets/Group35.svg";
import Group36 from "../../../../assets/Group36.svg";
import Group2111 from "../../../../assets/Group2111.png";
import lookingimg from "../../../../assets/Looking teacher BG.svg";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast, ToastContainer } from 'react-toastify';
import arrow2 from "../../../../assets/arrow2.svg";
import { Button, Dialog, TextField, Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, } from "@mui/material";
import { Controller } from "react-hook-form";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import DottedArrow from "../../../../assets/DottedArrow.svg";
import { MuiOtpInput } from "mui-one-time-password-input";


const sxStyle = {
  display: "flex",
  justifyContent: { xs: "center" },
  alignItems: "center",
};

const MathematicsHomeTuitionLucknow = () => {
  const [error, setError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const [selectedText, setSelectedText] = useState("");
  const [seoPages, setSeoPages] = useState([]);

  const toggleSidebar = (text, seoPages) => {
    setIsOpen((prev) => !prev);
    setSelectedText(text);
    setSeoPages(seoPages);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [quickLinks, setQuickLinks] = useState([]);

  async function getQuickLinks() {
    try {
      const response = await axios.get(
        `https://app.kanhahometutions.com/api/v1/quick-links`
      );

      setQuickLinks(response.data);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  }

  useEffect(() => {
    getQuickLinks();
    document.title = "Mathematics Home Tuition in Lucknow With Personal Tutor & Teaching Job  "; 
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "We provide Mathematics Home Tuition in Lucknow for Online & Offline for IIT-JEE, 12th, 11th and all classes. Book a Free Demo Class Today.");
  }, []);

  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");

  const styles = {
    grid: {
      display: "grid",
      gridTemplateColumns: isXs ? "repeat(3, 1fr)" : "repeat(1, 1fr)",
      gap: "20px",
    },
    box: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px",
      backgroundColor: "#FFEBE2",
      border: "1px solid #ccc",
      borderRadius: "7px",
      boxShadow: "7px 7px 1px rgba(10, 10, 10, 0.17)",
      height: "3.7rem",
      width: "18rem",
      fontWeight: "500",
      cursor: "pointer",
      textAlign: "left",
    },
  };

    const [Menu, setMenu] = useState(false);
    const [otpNew, setOtpNew] = useState("");
    const handleChangeOtpNew = (NewValue) => {
      setOtpNew(NewValue);
    };
  
    const [openOtpNew, setOpenOtpNew] = useState(false);
  
    const handleOpenotpNew = () => {
      setOpenOtpNew(true);
    };
  
    const handleCloseOtpNew = () => {
      setOpenOtpNew(false);
    };
  
  
    const toggleMenu = () => {
      setMenu((prevOpen) => !prevOpen);
    };
    const [open, setOpen] = useState();
    const handleOpen = () => setOpen(true);
    const handleClose = (reason) => {
      if (reason !== "backdropClick") {
        setOpen(false);
      }
    };
    const [smsIdNew, setSmsIdNew] = useState(null);
    const [studentQueryFormData, setStudentQueryFormData] = useState(null);
    const schema = yup.object().shape({
      email: yup.string().email().required(),
      fullName: yup.string().required(),
      pincode: yup.string().required(),
      area: yup.string().required(),
      city: yup.string().required(),
      mobileNumber: yup.string().required(),
      subject: yup.string().required(),
      course: yup.string().required(),
    });
  
    const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
      control,
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        classMode: "1",
      },
    });
  
    const [selectedColor, setSelectedColor] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
  
    const onSubmitHandler = async (data) => {
      setOtpNew("");
      setLoading(true);
  
      let date = new Date();
      let randomnumber = Math.floor(Math.random() * 1000000);
      let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
      let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
      let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      let hours = new Intl.DateTimeFormat("en", { hour: "2-digit", hour12: false, }).format(date);
      let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(date);
      let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(date);
      let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;
  
      const formData = new FormData();
      formData.append("email", data.email);
      formData.append("area", data.area);
      formData.append("fullName", data.fullName);
      formData.append("pincode", data.pincode);
      formData.append("course", data.course);
      formData.append("subject", data.subject);
      formData.append("classMode", data.classMode);
      formData.append("city", data.city);
      formData.append("mobile", data.mobileNumber);
      formData.append("token", CurrentDateTime);
      formData.append("smsType", "generalQuery");
      setStudentQueryFormData(formData);
  
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
  
      try {
        const response = await axios.post(
          "https://app.kanhahometutions.com/api/v2/notifySMS",
          formData,
          config
        );
  
        if (response.status === 200) {
          toast.success(response.data.message);
          setLoading(false);
          setOpenOtpNew(true);
          setOpen(false);
          setSmsIdNew(response.data.data.smsID.toString());
          reset();
        } else {
          toast.warning(response.data.message ?? "Something Went Wrong");
          setLoading(false);
        }
      } catch (error) {
        toast.error(
          error?.response.data.message ?? "An error occurred. Please try again."
        );
        setLoading(false);
      }
    };
  
    useEffect(() => {
  
    }, []);
  
    const handleResendOtpNew = async (e) => {
      e.preventDefault();
      setLoading2(true);
  
      let date = new Date();
      let randomnumber = Math.floor(Math.random() * 1000000);
      let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
      let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        date
      );
      let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      let hours = new Intl.DateTimeFormat("en", {
        hour: "2-digit",
        hour12: false,
      }).format(date);
      let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
        date
      );
      let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
        date
      );
      let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;
  
      const tempFormData = new FormData();
      tempFormData.append("smsId", smsIdNew);
      tempFormData.append("mobile", studentQueryFormData.get("mobile"));
      tempFormData.append("smsType", "generalQuery");
      tempFormData.append("token", CurrentDateTime);
  
      try {
        const response = await axios.post(
          "https://app.kanhahometutions.com/api/v2/resendOTP",
          tempFormData
        );
  
        if (response.data.success.toString() === "true") {
          toast.success(response.data.message);
          setSmsIdNew(response.data.data.smsID.toString());
          setLoading2(false);
        } else {
          toast.error(response.data.message);
          setLoading2(false);
        }
      } catch (error) { }
    };
  
    const handleSubmitOtpNew = async (e) => {
      e.preventDefault();
      setLoading(true);
  
      let date = new Date();
      let randomnumber = Math.floor(Math.random() * 1000000);
      let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
      let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        date
      );
      let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      let hours = new Intl.DateTimeFormat("en", {
        hour: "2-digit",
        hour12: false,
      }).format(date);
      let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
        date
      );
      let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
        date
      );
      let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;
  
      const formData = new FormData();
      formData.append("email", studentQueryFormData.get("email"));
      formData.append("area", studentQueryFormData.get("area"));
      formData.append("fullName", studentQueryFormData.get("fullName"));
      formData.append("pincode", studentQueryFormData.get("pincode"));
      formData.append("course", studentQueryFormData.get("course"));
      formData.append("subject", studentQueryFormData.get("subject"));
      formData.append("classMode", studentQueryFormData.get("classMode"));
      formData.append("city", studentQueryFormData.get("city"));
      formData.append("mobile", studentQueryFormData.get("mobile"));
      formData.append("token", CurrentDateTime);
      formData.append("smsType", "generalQuery");
      formData.append("smsId", smsIdNew);
      formData.append("smsOtp", otpNew);
      setStudentQueryFormData(formData);
  
      try {
        const response = await axios.post(
          "https://app.kanhahometutions.com/api/v2/verifyOtp",
          formData
        );
  
        if (response.data.success.toString() === "true") {
          toast.success(response.data.message);
          setOpenOtpNew(false);
          setSmsIdNew(response.data.data.smsID.toString());
          setLoading(false);
          setOtpNew("");
        } else {
          toast.error(response.data.message ?? "OTP does not match.");
          setLoading(false);
        }
      } catch (error) {
        toast.error(error?.response?.data.message);
        setLoading(false);
      }
    };

  if (error) {
    return (
      <>
        <NotFound />
      </>
    );
  }


  return (
    <>
      <WhatAppMobile />
      <NavBar />


      <div
        style={{
          width: "100%",
          backgroundColor: isXs ? "" : "#CB8B65",
          height: isXs ? "d" : "50rem",
        }}
      >
        {/* Background Image */}
        <img
          style={{
            width: "100%",
            display: isXs ? "" : "none",
            position: "relative",
            top: 0,
            left: 0,
            objectFit: 'cover',
            height: "100%",
          }}
          src={headerimg}
          alt="headerimg"
        />

        {/* Content Over the Image */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isXs ? "" : "column",
            position: "absolute",
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            zIndex: 0,
            padding: '0px 5%'
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: isXs ? "1.5rem" : "2rem",
              width: isXs ? "50%" : "",
              justifyContent: isXs ? "" : "center",
              alignItems: isXs ? "" : "center",
            }}
          >
            <h3
              className="text-white"
              style={{
                fontSize: isXs ? "1.5vw" : "4.8vw",
                display: isXs ? "" : "",
              }}
            >
              Welcome to Kanha Home Tutions
            </h3>

            <h2
              className="text-white fw-bold"
              style={{
                fontSize: isXs ? "3vw" : "6.6vw",
                lineHeight: isXs ? "3rem" : "1.8rem",
                textAlign: isXs ? "" : "center",
              }}
            >
              Best Tutor for <br /> Home and Online Tutions
            </h2>

            <img src={line2} style={{ width: "25%", maxWidth: "200px" }} />
            <div
              className="text-white"
              style={{
                width: isXs ? "100%" : "70%",
                fontSize: isXs ? "1vw" : "3.5vw",
                textAlign: isXs ? "" : "center",
              }}
            >
              <span>
                {" "}
                Connect with expert tutors for online or home tuitions, tailored
                to your learning needs and personal style. We offer classes for
                IIT-JEE, NEET, NDA, 12th, 11th, and all subjects across all
                grades, available all over India.
              </span>
            </div>
                       <button
                         className="py-2 px-2"
                         onClick={handleOpen}
                         type="button"
                         style={{
                           backgroundColor: "#FFDB7E",
                           border: "none",
                           color: "#866D2C",
                           borderRadius: "5px",
                           fontWeight: "bold",
                           fontSize: isXs ? "1.5rem" : "1.5rem",
                           width: isXs ? "80%" : "23rem",
                           height: isXs ? "4rem" : "5rem",
                           boxShadow: "5px  5px 2px rgb(0,0,0, .2)",
                         }}
                       >
                         Get a Free Demo Class
                         <img
                           src={DottedArrow}
                           style={{
                             width: "14%",
                             maxWidth: "25px",
                             marginLeft: "5%",
                           }}
                           alt="dotarrow"
                         />
                       </button>
          </div>

          {/* Tutor Image */}
          <div
            style={{
              display: "flex",
              justifyContent: isXs ? "end" : "center",
              alignItems: "center",
              marginTop: isXs ? "" : "2rem",
            }}
          >
            <img style={{ width: "90%" }} src={Tutor2} />
          </div>
        </div>
      </div>

      <Grid
             container
             style={{
               position: "relative",
               backgroundColor: isXs ? "transparent" : "#F6EBDC",
             }}
             sx={sxStyle}
           >
             <img 
          style={{
          position: "absolute",
          top: isXs ? "-25%" : "0%",
          left: 0,
          width: "100%",
          height: "auto",
          zIndex: -2,
          display: isXs ? "" : "none",
        }}
        src={lookingimg} alt="img" />

             <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
               <div className="d-flex justify-content-center">
                 <div
                   className="text-center"
                   style={{ marginTop: isXs ? "5%" : "12%" }}
                 >
                   <h1
                     style={{
                       color: "#A6653F",
                       fontSize: isXs ? "45px" : "6vw",
                       fontWeight: "bold",
                     }}
                   >
Mathematics Home Tuition in Lucknow 
</h1>
                   <img
                     src={Group2081}
                     alt="new"
                     style={{
                       width: isXs ? "80%" : "90%",
                       marginTop: isXs ? "7%" : "12%",
                     }}
                   />
                   <div
                     className="text-center"
                     style={{
                       marginTop: isXs ? "50px" : "12%",
                       marginBottom: isXs ? "" : "40%",
                     }}
                   >

<a href="/student-signin">
                  <button
                    style={{
                      padding: ".8rem 0.5rem",
                      border: "none",
                      boxShadow: "4px 8px 4px rgb(0, 0, 0, .1)",
                      borderRadius: "5px",
                      fontSize: isXs ? "1.4rem" : '1rem',
                      marginTop: isXs ? "0.5rem" : "2rem",
                      fontWeight: "bold",
                      backgroundColor: "#FFDB7E",
                      color: "#866D2C",
                      gap: "40rem",
                      width: isXs ? '25rem' : '22.4rem',
                    }}
                    type="button"
                  >
                    Hire Your Perfect Learning Partner
                  </button>
                </a>

                     <img
                       src={Group35}
                       alt="group35"
                       style={{
                         position: "absolute",
                         bottom: "0%",
                         left: "5%",
                         display: isXs ? "none" : "",
                       }}
                     />
                     <img
                       src={Group36}
                       alt="group36"
                       style={{
                         position: "absolute",
                         bottom: "0%",
                         right: "5%",
                         display: isXs ? "none" : "",
                       }}
                     />
                   </div>
                 </div>
               </div>
             </Grid>
           </Grid>
     
           {/* Section3 */}
           <Grid container sx={sxStyle} style={{ marginTop: isXs ? "14%" : "10%" }}>
             <Grid item xs={10} sm={5} md={6} lg={6} xl={6} xxl={6}>
               <div
                 style={{
                   marginLeft: isXs ? "5%" : "",
                   textAlign: isXs ? "" : "center",
                 }}
               >
                 <h2 style={{ fontWeight: "bold" }}>
                 Best Home Tutor for Offline and Online Classes in Lucknow
                </h2>
                 <div
                   style={{
                     color: "#CB8B65",
                     marginTop: "3%",
                     fontSize: isXs ? "1.5vw" : "4vw",
                   }}
                 >
                   Your Gateway to Personalized Education
                 </div>
                 <div
                   style={{
                     marginTop: isXs ? "1%" : "10%",
                     fontSize: isXs ? "1.1vw" : "2.5",
                     textAlign: "justify",
                   }}
                 >
                   <div style={{ fontSize: '15px' }}>Unlock Your Child's Potential with Kanha Home Tutions! Our experienced tutors provide personalised education and best home tuitions in Lucknow to help your child excel in their studies. We offer subject-wise expertise and tuition for CBSE, IIT-JEE, NEET, NDA and other boards. Our services are flexible and budget-friendly, with online and offline classes available. Find the best home tutor in Lucknow for your child with us and ensure their success in competitive exams like IIT-JEE, NEET, Olympiad, BITSAT, AIIMS, KVPY 12th,11th ( CBSE, ICSE, IB,& State Boards). With Kanha Home Tutions, your child's future can shine bright! </div>
                   <div style={{ marginTop: '20px', fontSize: '15px', border: '1px solid rgb(10,10,10,0.3)', backgroundColor: '#FFE2AB', padding: '10px 20px', borderRadius: '10px' }}>
                   <h4 style={{fontSize:'18px', fontWeight:'500', padding:'3px 0px'}}>Best Mathematics Home Tuition in Lucknow</h4>
                   <div>We Provide  Offline and Online Classes With a personal tutor.   
                   One Student, One Teacher Online Classes.  </div>
                   <div style={{marginTop:'10px'}}> We provide the best Mathematics home tutors for IIT-JEE (Main & Advanced), BITSAT, Olympiads, and Foundation courses for Classes 11 and 12. Learn from top tutors in Lucknow— experienced IITians and subject experts dedicated to your success.</div>
                    </div>
                 </div>
               </div>
             </Grid>
     
             <Grid
               item
               xs={10}
               sm={5}
               md={6}
               lg={6}
               xl={6}
               xxl={6}
               style={{ textAlign: "center" }}
             >
               <img
                 src={Group2111}
                 alt="group2111"
                 style={{
                   width: isXs ? "70%" : "95%",
                   marginTop: isXs ? "10%" : "15%",
                 }}
               />
             </Grid>
           </Grid>
      <Grid
        container
        sx={{
          backgroundColor: "#CB8B65",
          display: "flex",
          marginTop: '70px'
        }}
      >
        <div
          className="py-4 d-flex justify-content-center"
          style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "28px",
            width: "100%",
            marginTop: isXs ? "3%" : "12%",
            margin: "0 auto",
          }}
        >
          Why Choose Our Tutors?
        </div>

        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: isXs ? "space-evenly" : "center",
            alignItems: isXs ? "" : "center",
            marginTop: isXs ? "1%" : "20%",
          }}
        >
          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{ position: "relative" }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Leaderstyle}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-20%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Proven Expertise:
              </div>
              <div>
                Each tutor is rigorously selected based on their knowledge,
                teaching experience, and ability to adapt to different learning
                styles and needs.
              </div>
              <div style={{ marginBottom: "15%" }}>
                <img
                  src={Pin1}
                  style={{
                    position: "absolute",
                    bottom: "-10%",
                    left: "8%",
                  }}
                />
              </div>
            </div>

            <div className="text-end" style={{ marginTop: "30%" }}>
              <img src={Scale} style={{ display: isXs ? "none" : "none" }} />
            </div>
            <img
              src={Scale}
              style={{
                position: "absolute",
                zIndex: 2,
                left: "-3rem",
                bottom: "1rem",
                width: "30%",
                display: isXs ? "none" : "",
              }}
            />
          </Grid>

          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{ marginTop: "5%" }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Pin2}
                  style={{
                    position: "absolute",
                    top: "-12%",
                    left: "8%",
                  }}
                />
              </div>
              <div>
                <img
                  src={Leaderstyle2}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-18%",
                    right: "36%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Customized Approach:
              </div>
              <div style={{ marginBottom: "15%" }}>
                Our tutors understand that each student is unique. They
                customize their teaching methods to match individual learning
                paces and preferences, ensuring optimal comprehension and
                retention.
              </div>
            </div>
          </Grid>

          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{
              position: "relative",
              marginTop: isXs ? "" : "30%",
              marginBottom: isXs ? "" : "20%",
            }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Leaderstyle3}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-20%",
                    right: "8%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Results-Oriented:
              </div>
              <div>
                Focused on achieving tangible academic improvements, our tutors
                are committed to helping each student reach and surpass their
                academic goals.
              </div>
              <div style={{ marginBottom: "15%" }}>
                <img
                  src={Pin3}
                  style={{
                    position: "absolute",
                    bottom: "-9%",
                    right: "8%",
                  }}
                />
              </div>
            </div>
            <div
              className="col-lg-12 d-flex justify-content-end"
              style={{ backgroundColor: "#CB8B65" }}
            >
              {/* <img
                src={Frame}
                style={{
                  width: "40%",
                  position: "absolute",
                  right: "-25%",
                  marginTop: "30%",
                  display: isXs ? "" : "none",
                }}
              /> */}
              {/* <img
                src={Frame}
                style={{
                  position: "absolute",
                  zIndex: 2,
                  right: "-2rem",
                  width: "30%",
                  display: isXs ? "none" : "",
                }}
              /> */}
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: isXs ? "space-evenly" : "center",
            alignItems: isXs ? "" : "center",
            marginTop: isXs ? "1%" : "10%",
          }}
        >
          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{ position: "relative" }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Leaderstyle4}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-20%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Best Home Tutors:
              </div>
              <div>
                We provide the best home tutors in India, ensuring that students receive the highest quality education.
              </div>
              <div style={{ marginBottom: "15%" }}>
                <img
                  src={Pin1}
                  style={{
                    position: "absolute",
                    bottom: "-10%",
                    left: "8%",
                  }}
                />
              </div>
            </div>

            <div className="text-end" style={{ marginTop: "30%" }}>
              <img src={Scale} style={{ display: isXs ? "" : "none" }} />
            </div>
            <img
              src={Scale}
              style={{
                position: "absolute",
                zIndex: 2,
                left: "-3rem",
                bottom: "1rem",
                width: "30%",
                display: isXs ? "none" : "",
              }}
            />
          </Grid>

          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{ marginTop: "5%" }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Pin2}
                  style={{
                    position: "absolute",
                    top: "-12%",
                    left: "8%",
                  }}
                />
              </div>
              <div>
                <img
                  src={Leaderstyle5}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-18%",
                    right: "36%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Expert Coaching:
              </div>
              <div style={{ marginBottom: "15%" }}>
                IIT-JEE, NEET & BITSAT Coaching: Our teachers have extensive experience in coaching students for IIT-JEE, NEET & BITSAT with a deep understanding of the exam pattern and syllabus.
              </div>
            </div>
          </Grid>

          <Grid
            item
            xs={10}
            sm={10}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            sx={{
              position: "relative",
              marginTop: isXs ? "" : "30%",
              marginBottom: isXs ? "" : "20%",
            }}
          >
            <div
              className="rounded-5"
              style={{
                backgroundColor: "white",
                padding: "20px",
                position: "relative",
              }}
            >
              <div>
                <img
                  src={Leaderstyle6}
                  style={{
                    width: "30%",
                    position: "absolute",
                    top: "-20%",
                    right: "8%",
                  }}
                />
              </div>
              <div className="fw-bolder fs-5 py-2" style={{ marginTop: "15%" }}>
                Excellence:
              </div>
              <div>
                11th and 12th Class Tuitions: Our teachers are experts in their respective subjects and have a proven track record of helping students achieve high grades in their 11th and 12th class ( CBSE, ICSE,IB,& State Boards) exams.
              </div>
              <div style={{ marginBottom: "15%" }}>
                <img
                  src={Pin3}
                  style={{
                    position: "absolute",
                    bottom: "-9%",
                    right: "8%",
                  }}
                />
              </div>
            </div>
            <div
              className="col-lg-12 d-flex justify-content-end"
              style={{ backgroundColor: "#CB8B65" }}
            >
              <img
                src={Frame}
                style={{
                  width: "40%",
                  position: "absolute",
                  right: "-25%",
                  marginTop: "30%",
                  display: isXs ? "" : "none",
                }}
              />
              <img
                src={Frame}
                style={{
                  position: "absolute",
                  zIndex: 2,
                  right: "-2rem",
                  width: "30%",
                  display: isXs ? "none" : "",
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid container sx={sxStyle}>
        <div
          className="text-center"
          style={{
            marginTop: isXs ? "5%" : "10%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: isXs ? "1.6vw" : "4.5vw",
              fontWeight: "bold",
              width: isXs ? "60%" : "70%",
            }}
          >
            How Our Kanha Home Tutions Service Simplifies Your Search for the
            Perfect Tutor
          </div>
          <img
            src={line3}
            style={{
              width: "30%",
              maxWidth: "200px",
              margin: "auto",
              marginTop: isXs ? "1rem" : "2rem",
            }}
          />
        </div>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          sx={sxStyle}
        >
          <div
            style={{
              marginTop: isXs ? "5%" : "10%",
              backgroundColor: "#F6EBDC",
              width: isXs ? "65%" : "80%",
              height: isXs ? "17.2rem" : "40rem",
              position: "relative",
              borderTopLeftRadius: isXs ? "500px" : "200px",
              borderBottomLeftRadius: isXs ? "500px" : "",
              borderBottomRightRadius: isXs ? "500px" : "",
              borderTopRightRadius: isXs ? "" : "200px",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={10}
                sm={4}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                sx={{ margin: isXs ? "" : "0 auto" }}
              >
                <img
                  src={Step1}
                  alt="Step1"
                  style={{
                    width: isXs ? "94%" : "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "50%",
                    marginTop: isXs ? "" : "11%",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                md={8}
                lg={8}
                xl={8}
                xxl={8}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ marginRight: isXs ? "8%" : "0 auto" }}>
                  <div
                    className="d-flex fw-bold"
                    style={{
                      fontSize: isXs ? "2vw" : "5vw",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Grid
                      container
                      justifyContent={isXs ? "flex-start" : "center"}
                      sx={{ gap: isXs ? "0.5rem" : "" }}
                    >
                      <Grid item xs={10} sm={2} md={2} lg={2} xl={2} xxl={2}>
                        <div
                          style={{
                            color: "#CB8B65",
                            textAlign: isXs ? "" : "center",
                            marginTop: isXs ? "" : "11%",
                          }}
                        >
                          Step 1
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={10}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        xxl={5}
                        sx={{ right: "5%" }}
                      >
                        <div style={{ textAlign: isXs ? "" : "center" }}>
                          Sign Up Easily
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div
                    style={{
                      fontSize: isXs ? "1vw" : "4vw",
                      textAlign: isXs ? "" : "center",
                      width: isXs ? "" : "80%",
                      margin: isXs ? "" : "0 auto",
                      marginTop: isXs ? "2%" : "8%",
                    }}
                  >
                    Start by registering on the Kanha Home Tuitions website or
                    app, or simply contact us directly. This step allows you to
                    clarify your specific tutoring needs and preferences,
                    ensuring we connect you with the ideal candidates.
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          sx={sxStyle}
          style={{ display: isXs ? "" : "none" }}
        >
          <div
            className="d-flex align-items-center py-3"
            style={{
              marginTop: "5%",
              backgroundColor: "#CB8B65",
              width: isXs ? "65%" : "80%",
              height: isXs ? "17.2rem" : "30rem",
              position: "relative",
              borderTopLeftRadius: isXs ? "" : "200px",
              borderBottomLeftRadius: isXs ? "500px" : "",
              borderBottomRightRadius: isXs ? "500px" : "",
              borderTopRightRadius: isXs ? "500px" : "200px",
            }}
          >
            <Grid
              container
              sx={{ display: "flex", justifyContent: isXs ? "flex-end" : "" }}
            >
              <Grid
                item
                xs={10}
                sm={7}
                md={7}
                lg={7}
                xl={7}
                xxl={7}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div>
                  <div
                    className="d-flex fw-bold"
                    style={{ fontSize: "2vw", gap: "1rem" }}
                  >
                    <div style={{ color: "#FFDB7E", width: "100px" }}>
                      Step 2
                    </div>
                    <div style={{ color: "white", width: "80%" }}>
                      Post Tutoring Requirements
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: "1vw",
                      color: "white",
                      width: "90%",
                      marginTop: isXs ? "2%" : "",
                    }}
                  >
                    Create a detailed post outlining your child’s academic
                    needs, preferred schedule, and any special considerations.
                    You can also browse posts from our extensive network of
                    qualified tutors to find the right match.
                  </div>
                </div>
              </Grid>
              <Grid
                item
                xs={10}
                sm={4}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <img
                  src={Step2}
                  alt="Step2"
                  style={{
                    width: isXs ? "95%" : "120%",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "50%",
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          sx={sxStyle}
          style={{ display: isXs ? "none" : "", marginTop: "5%" }}
        >
          <div
            style={{
              marginTop: "5%",
              backgroundColor: "#CB8B65",
              width: isXs ? "65%" : "80%",
              height: isXs ? "17.2rem" : "40rem",
              position: "relative",
              borderTopLeftRadius: isXs ? "500px" : "200px",
              borderBottomLeftRadius: isXs ? "500px" : "",
              borderBottomRightRadius: isXs ? "500px" : "",
              borderTopRightRadius: isXs ? "" : "200px",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={10}
                sm={5}
                md={5}
                lg={5}
                xl={5}
                xxl={5}
                sx={{ margin: isXs ? "" : "0 auto" }}
              >
                <img
                  src={Step2}
                  alt="Step2"
                  style={{
                    width: isXs ? "93%" : "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "50%",
                    marginTop: isXs ? "" : "11%",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                md={7}
                lg={7}
                xl={7}
                xxl={7}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ margin: isXs ? "" : "0 auto" }}>
                  <div
                    className="d-flex fw-bold"
                    style={{
                      fontSize: isXs ? "2vw" : "5vw",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Grid
                      container
                      justifyContent={isXs ? "flex-start" : "center"}
                    >
                      <Grid
                        item
                        xs={10}
                        sm={2.5}
                        md={2.5}
                        lg={2.5}
                        xl={2.5}
                        xxl={2.5}
                      >
                        <div
                          style={{
                            color: "#FFDB7E",
                            marginRight: "0.5rem",
                            textAlign: isXs ? "" : "center",
                            marginTop: isXs ? "" : "11%",
                          }}
                        >
                          Step 2
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={10}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        xxl={5}
                        sx={{ right: "5%" }}
                      >
                        <div
                          style={{
                            textAlign: isXs ? "" : "center",
                            color: "white",
                          }}
                        >
                          Post Tutoring Requirements
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div
                    style={{
                      fontSize: isXs ? "1vw" : "4vw",
                      color: "white",
                      textAlign: isXs ? "" : "center",
                      width: isXs ? "" : "80%",
                      margin: isXs ? "" : "0 auto",
                      marginTop: isXs ? "" : "8%",
                    }}
                  >
                    Create a detailed post outlining your child’s academic
                    needs, preferred schedule, and any special considerations.
                    You can also browse posts from our extensive network of
                    qualified tutors to find the right match.
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          sx={sxStyle}
          style={{ marginTop: "5%" }}
        >
          <div
            style={{
              marginTop: "0.2%",
              backgroundColor: "#F6EBDC",
              width: isXs ? "65%" : "80%",
              height: isXs ? "17.2rem" : "42rem",
              position: "relative",
              borderTopLeftRadius: isXs ? "500px" : "200px",
              borderBottomLeftRadius: isXs ? "500px" : "",
              borderBottomRightRadius: isXs ? "500px" : "",
              borderTopRightRadius: isXs ? "" : "200px",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={10}
                sm={4}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                sx={{ margin: isXs ? "" : "0 auto" }}
              >
                <img
                  src={Step3}
                  alt="Step3"
                  style={{
                    width: isXs ? "94%" : "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "50%",
                    marginTop: isXs ? "" : "11%",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                md={8}
                lg={8}
                xl={8}
                xxl={8}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ margin: isXs ? "" : "0 auto" }}>
                  <div
                    className="d-flex fw-bold"
                    style={{
                      fontSize: isXs ? "2vw" : "5vw",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Grid
                      container
                      justifyContent={isXs ? "flex-start" : "center"}
                      sx={{ gap: isXs ? "0.5rem" : "" }}
                    >
                      <Grid item xs={10} sm={2} md={2} lg={2} xl={2} xxl={2}>
                        <div
                          style={{
                            color: "#CB8B65",
                            textAlign: isXs ? "" : "center",
                            marginTop: isXs ? "" : "11%",
                          }}
                        >
                          Step 3
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={10}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        sx={{ right: "5%" }}
                      >
                        <div style={{ textAlign: isXs ? "" : "center" }}>
                          Choose the Ideal Tutor
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div
                    style={{
                      fontSize: isXs ? "1vw" : "4vw",
                      textAlign: isXs ? "" : "center",
                      width: isXs ? "95%" : "80%",
                      margin: isXs ? "" : "0 auto",
                      marginTop: isXs ? "2%" : "8%",
                    }}
                  >
                    After posting your requirements, you'll receive responses
                    from our vetted tutors. Arrange a demo class to assess the
                    tutor’s compatibility with your child’s learning style and
                    needs. Once satisfied, you can hire the tutor and discuss
                    any further details directly.
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      {/* Section6 */}
      <div style={{ marginTop: "8rem" }}>
        <img
          src={Frame24}
          alt="Frame24"
          style={{
            position: "absolute",
            width: "100%",
            display: isXs ? "" : "none",
            height: "auto",
          }}
        />
        <img
          src={Group221}
          alt="Group221"
          style={{
            position: "absolute",
            paddingTop: "4.2rem",
            left: "3.3rem",
            width: isXs ? "95.4%" : "0%",
          }}
        />
      </div>

      <div
        className="container-fluid"
        style={{
          position: "relative",
          overflow: "hidden",
          zIndex: 3,
          backgroundColor: isXs ? "" : "#CB8B65",
          padding: isXs ? "" : "3rem 0rem",
          height: isXs ? "auto" : "570px",
        }}
      >
        <div
          className="text-center"
          style={{
            marginTop: isXs ? "6%" : "1%",
            height: isXs ? "20rem" : "",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: isXs ? "2.2vw" : "6.6vw",
              fontWeight: "bold",
              width: isXs ? "55%" : "90%",
              color: "white",
            }}
          >
            Kickstart Your Child’s Academic Success Today!
          </div>
          <div
            style={{
              fontSize: isXs ? "1.2vw" : "4vw",
              width: isXs ? "70%" : "90%",
              color: "white",
              marginTop: isXs ? "3%" : "8%",
              textAlign: isXs ? "" : "center",
            }}
          >
            Forget the hassle of endless searching for 'tuition near me'. With
            Kanha Home Tutions, discover a personalized, efficient, and reliable
            approach to finding the perfect tutor for your child. Join our
            community of satisfied parents and witness your child's educational
            transformation.
          </div>
          <div
            className="d-flex justify-content-evenly"
            style={{
              width: isXs ? "60%" : "85%",
              marginTop: isXs ? "4%" : "10%",
              fontSize: "1.4vw",
            }}
          >
            <button
              className="py-2"
              type="button"
              // onClick={handleOpen}
              style={{
                backgroundColor: "#FFDB7E",
                color: "#866D2C",
                border: "none",
                borderRadius: "3px",
                width: isXs ? "70%" : "20rem",
                height: isXs ? "4rem" : "5rem",
                fontWeight: "bold",
                fontSize: isXs ? "1.5rem" : "1.6rem",
                boxShadow: "5px  5px 2px rgb(0,0,0, .2)",
              }}
            >
              <a style={{ textDecoration: 'none', color: 'black' }} href="/student-signin">
                Post Your Requirments
              </a>
            </button>


          </div>
          <img
            src={Globe}
            style={{
              position: "absolute",
              zIndex: 2,
              right: "-1rem",
              top: "1rem",
              width: "12%",
              display: isXs ? "none" : "",
            }}
          />
        </div>

        <img
          src={NoteBook}
          style={{
            position: "absolute",
            zIndex: 2,
            left: "3rem",
            bottom: "-1rem",
            width: "15%",
            display: isXs ? "none" : "",
          }}
        />
      </div>

      <div
        style={{
          height: isXs ? "800px" : "1150px",
          backgroundColor: "#F6EBDC",
          width: "100%",
          marginTop: isXs ? "2rem" : "0rem",
          marginBottom: isXs ? "0rem" : "7rem",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "28px",
              paddingTop: isXs ? "120px" : "50px",
              fontWeight: "bold",
            }}
          >
            Explore Categories
          </div>
        </div>
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: "bolder",
            marginTop: isXs ? "10px" : "20px",
            textAlign: isXs ? "center" : "center",
          }}
        >
          Tutors for home and online Tution
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isXs ? "repeat(5, 250px)" : "repeat(2, 1fr)",
            justifyItems: "center",
            alignItems: "center",
            justifyContent: "center",
            padding: isXs ? "2rem 1rem" : "2rem 1rem",
            gap: isXs ? "" : "0.7rem",
            rowGap: isXs ? "50px" : "2rem",
          }}
        >
          {[
            { img: class1_6, label: "Class 1-6 Tution" },
            { img: class7, label: "Class 7 Tution" },
            { img: class8, label: "Class 8 Tution" },
            { img: class9, label: "Class 9 Tution" },
            { img: class10, label: "Class 10 Tution" },
            { img: class11, label: "Class 11 Tution" },
            { img: class12, label: "Class 12 Tution" },
            { img: IIT, label: "IIT-JEE Tution" },
            { img: Neet, label: "NEET Tution" },
            { img: NDA, label: "NDA Tution" },
          ].map((item, index) => (
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to="/student-signin"
              key={index}
            >
              <div
                key={index}
                style={{
                  gap: "10px",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <div>
                  <img
                    src={item.img}
                    alt=""
                    style={{
                      objectFit: "cover",
                      borderRadius: "7px",
                      height: isXs ? "150px" : "120px",
                      width: "100%",
                      maxWidth: "220px",
                    }}
                  />
                </div>
                <div>{item.label}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div style={{ padding: isXs ? '40px 70px' : '40px 30px', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: isXs ? '80px' : '10px', }}>


        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <span style={{ width: isXs ? "1000px" : '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#F8E7C9', padding: isXs ? '20px 35px' : '10px 10px', color: 'black', borderRadius: '20px', marginTop: '0px' }}>
            <span style={{ fontSize: '26px', fontWeight: '500px', textAlign: 'center' }}>Best Tutor for Home and Online Tution</span>
            <hr style={{ marginTop: '5px', marginBottom: '5px', border: '1px', borderTop: '2px solid rgb(137, 57, 11)', width: isXs ? '76%' : '100%', marginLeft: isXs ? '70px' : '0px', color: 'rgb(137, 57, 11)' }} />
            <span style={{ fontSize: '16px', fontWeight: '500px', textAlign: 'center', marginTop: '10px', width: isXs ? '100%' : '100%' }}>Connect with expert tutors for online or home tuitions, tailored to your learning needs and personal style. We offer classes for IIT-JEE, NEET, NDA, 12th, 11th, and all subjects across all grades, available all over India.</span>
          </span>
        </div>

        <div style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Why Choose Kanha Home Tuition?</div>
        <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Home Tution:</span> </div>
        <div style={{ fontSize: '16px' }}>Experienced and qualified home tutors for all subjects and classes, including IIT JEE, NEET, 12th, 11th, and up to 10th. Our home tutors provide personalized attention and guidance in Mathematics, Physics, Chemistry, Biology, and all other subjects to help students achieve their academic goals.</div>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Best Home Tutors:</span> </div>
        <div style={{ fontSize: '16px' }}>Our team of expert home tutors are highly qualified and experienced in their respective subjects. </div>
        <ul style={{ display: 'flex', flexDirection: 'column', gap: '5px', paddingLeft: '0px' }}>
          <li style={{ fontSize: '16px', listStyle: "none" }}><span style={{ fontSize: '16px', fontWeight: '500' }}>1. Personalized Attention:</span> We provide one-on-one attention to each student, ensuring they receive the best possible guidance and support. </li>
          <li style={{ fontSize: '16px', listStyle: "none" }}><span style={{ fontSize: '16px', fontWeight: '500' }}>2. Flexible Scheduling:</span> We understand that every student's schedule is different, which is why we offer flexible scheduling to fit your needs. </li>
          <li style={{ fontSize: '16px', listStyle: "none" }}><span style={{ fontSize: '16px', fontWeight: '500' }}>3. Proven Track Records:</span> Our home tutors have a proven track record of success, with many students achieving top grades and securing admission to top universities.</li>
        </ul>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Online Tution ( One to One ):</span> </div>
        <div style={{ fontSize: '16px' }}>Flexible and convenient online tuition for students of all ages and subjects, including IIT JEE, NEET, 12th, 11th, and up to 10th. Our online tutors provide one-on-one attention and guidance in Mathematics, Physics, Chemistry, Biology, and all other subjects to help students learn at their own pace. </div>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Online Classes:</span> </div>
        <div style={{ fontSize: '16px' }}>IIT- JEE, NEET, NDA (One to One) Attention  </div>
        <div style={{ fontSize: '16px' }}>Our online classes provide specialized coaching for, IIT- JEE, NEET, NDA. with a focus on personalized attention and guidance for each student. Our experienced and qualified tutors offer online coaching, IIT- JEE, NEET, NDA ensuring that students receive individualized support and guidance to achieve their academic goals. </div>
        <ul style={{ display: 'flex', flexDirection: 'column', gap: '5px', }}>
          <li style={{ fontSize: '16px' }}>( One to One ) online coaching for IIT- JEE,NEET,NDA </li>
          <li style={{ fontSize: '16px' }}>Experienced and qualified tutors</li>
          <li style={{ fontSize: '16px' }}>Personalized attention and guidance</li>
          <li style={{ fontSize: '16px' }}>Flexible and convenient online classes</li>
          <li style={{ fontSize: '16px' }}>Comprehensive study material and resources</li>
        </ul>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        <div style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Subjects and Levels We Cover</div>
        <div style={{ display: 'flex', gap: '3px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Maths Tutors:</span></div>
          <div style={{ fontSize: '16px' }}> Our experienced maths tutors provide expert guidance and support to help student’s master mathematical concepts. </div>
          <hr style={{ marginTop: '10px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

          <div></div>
        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Physics Tutors:</span></div>
          <div style={{ fontSize: '16px' }}> Our physics tutors are highly qualified and experienced in helping students understand complex physics concepts.</div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Chemistry Tutors:</span></div>
          <div style={{ fontSize: '16px' }}> Our chemistry tutors provide expert guidance and support to help students understand chemical reactions and processes.</div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Biology Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}> Our biology tutors are highly qualified and experienced in helping students understand biological concepts and processes. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>IIT JEE Tutors (Mains and Advanced): </span> </div>
          <div style={{ fontSize: '16px' }}> Our experienced IIT JEE tutors provide expert guidance and support to help students prepare for IIT JEE exams. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>NEET Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our NEET tutors are highly qualified and experienced in helping students prepare for NEET exams. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>NDA Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our NDA tutors provide expert guidance and support to help students prepare for NDA exams.</div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Commerce Tutors</span> </div>
          <div style={{ fontSize: '16px' }}> Our commerce tutors cover all subjects, including Accountancy, Business Studies, Economics, and more.</div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Arts Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our arts tutors cover all subjects, including History, Geography, Political Science, and more. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>12th Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our 12th tutors cover all subjects, including math, science, commerce, and arts.</div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}> 11th Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our 11th tutors cover all subjects, including math, science, commerce, and arts. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        </div>
        <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>CBSE Tutors:</span> </div>
          <div style={{ fontSize: '16px' }}>Our CBSE tutors are highly qualified and experienced in helping students prepare for CBSE exams. </div>
          <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Online Tutions and Tutors:</span> </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ fontSize: '16px' }}>1. We also provide online tutions and tutors for all subjects and levels, ensuring that students can learn from the comfort of their own homes. </div>
            <div style={{ fontSize: '16px' }}>2. Our online tutors are highly qualified and experienced, and use the latest technology to provide interactive and engaging lessons.</div>
          </div>
          <hr style={{ marginTop: '10px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <div style={{ fontSize: '16px' }}> <span style={{ fontSize: '18px', fontWeight: '500' }}>Services We Provide:</span> </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ fontSize: '16px' }}><span style={{ fontSize: '16px', fontWeight: '500' }}>1. Home Tutions:</span> We provide home tutions for all subjects and levels, ensuring that students receive personalized attention and guidance.</div>
            <div style={{ fontSize: '16px' }}><span style={{ fontSize: '16px', fontWeight: '500' }}>2. Online Tutions:</span> We provide online tutions for all subjects and levels, ensuring that students can learn from the comfort of their own homes. </div>
            <div style={{ fontSize: '16px' }}><span style={{ fontSize: '16px', fontWeight: '500' }}>3. Group Tutions:</span> We provide group tutions for students who prefer to learn in a group environment.</div>
            <div style={{ fontSize: '16px' }}><span style={{ fontSize: '16px', fontWeight: '500' }}>4. Test Preparation:</span> We provide test preparation services for students who are preparing for competitive exams.</div>

          </div>
          <hr style={{ marginTop: '10px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
        </div>
      </div>


      <div style={{ marginTop: "80px ", marginBottom: isXs ? "" : "100px" }}>
        <div style={{ position: "relative" }}>
          <div
            style={{
              textAlign: "center",
              backgroundColor: isXs ? "" : "#C9875F",
              height: isXs ? "" : "730px",
              borderBottomLeftRadius: "50px",
              borderTopRightRadius: "50px",
              display: "flex",
              justifyContent: "center",
              margin: isXs ? "" : "0px 5%",
            }}
          >
            <img
              style={{ width: isXs ? "80%" : "0%" }}
              src={QuicklinkBg}
              alt="QuicklinkBg"
            />
            <div
              style={{
                position: "absolute",
                top: "32px",
                fontSize: "28px",
                fontWeight: "bold",
                left: isXs ? "44.5%" : "",
                color: "white",
                display: "flex",
                flexDirection: "column",
                textAlign: isXs ? "" : "center",
              }}
            >
              Quick Links{" "}
              <img style={{ width: "70px" }} src={Linenew} alt="LineNEW" />
            </div>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div style={styles.grid}>
                {quickLinks.slice(0, 6).map((boxText, index) => (
                  <div
                    onClick={() =>
                      toggleSidebar(boxText.quick_link_name, boxText.seo_pages)
                    }
                    key={index}
                    style={styles.box}
                  >
                    {boxText.quick_link_name}
                    <img
                      src={ArrowNew}
                      style={{ height: "30px", marginLeft: "10px" }}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div style={{ position: "absolute", zIndex: "1000" }}>
          <div
            ref={sidebarRef}
            style={{
              position: "fixed",
              top: 40,
              right: 0,
              height: isXs ? "530px" : "750px",
              width: isXs ? "390px" : "340px",
              backgroundColor: "#efe8e8",
              color: "black",
              transform: isOpen ? "translateX(00)" : "translateX(100%)",
              transition: "transform 0.3s",
              boxShadow: "1px 2px 2px rgb(10, 10, 10 ,0.2)",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "0px",
                backgroundColor: "#A6653F",
                color: "white",
                padding: "10px 10px",
              }}
            >
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "18px",
                  paddingRight: "16px",
                  top: "0",
                  position: "sticky",
                  zIndex: "1000",
                }}
              >
                {/* Add this button text */}
                {selectedText}
              </div>
              {isOpen && (
                <div
                  onClick={() => toggleSidebar()}
                  style={{ cursor: "pointer", color: "white" }}
                >
                </div>
              )}{" "}
            </div>
            <div
              style={{
                overflowY: "auto",
                maxHeight: isXs ? "480px" : "700px",
                paddingBottom: "10px",
                paddingTop: "10px",
              }}
            >
              <div style={{ paddingLeft: "10px" }}>
                {seoPages.map((seoPage, index) => (
                  <a
                    href={`/${seoPage.txt_slug
                      .toLowerCase()
                      .replaceAll(" ", "-")}`}
                    key={index}
                    style={{
                      color: "black",
                      textDecoration: "none",
                      fontSize: "16px",
                    }}
                  >
                    <li
                      style={{
                        textIndent: "-1.5rem",
                        paddingLeft: "2rem ",
                        marginBottom: "15px",
                      }}
                      className="listiem"
                    >
                      {seoPage.txt_meta_title}
                    </li>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section7 Web */}
      <Grid
        container
        sx={{
          marginTop: "5%",
          display: isXs ? "" : "none",
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <div
            className="d-flex justify-content-center"
            style={{
              position: "relative",
              marginTop: "10%",
              marginBottom: "10%",
            }}
          >
            <img
              src={Frame25}
              alt="Frame24"
              style={{
                position: "absolute",
                width: "78%",
                height: "auto",
                zIndex: 2,
                left: "8.5rem",
                top: "-3rem",
              }}
            />
            <div
              className="d-flex align-items-center"
              style={{
                borderBottomRightRadius: "10px",
                height: "20rem",
                width: "80%",
                backgroundColor: "#F6EBDC",
                borderTopRightRadius: "150px",
                borderBottomLeftRadius: "150px",
              }}
            >
              <div
                style={{
                  maxWidth: "40%",
                  marginLeft: "6vw",
                  marginBottom: "5%",
                }}
              >
                <div style={{ fontSize: "1.5vw", width: "90%" }}>
                  Download the Kanha Home Tuitions Student and Tutor apps now on
                  Google Play Store!
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Section7 Mobile */}
      <Grid
        container
        sx={{
          marginTop: "5%",
          display: isXs ? "none" : "",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <img
            src={GroupPhone}
            alt="GroupPhone"
            style={{
              position: "absolute",
              width: "50%",
              height: "auto",
              zIndex: 1,
            }}
          />
          <img
            src={PhoneDoodlePlus}
            style={{
              position: "absolute",
              zIndex: 2,
              left: "3rem",
              top: "7rem",
            }}
          />
          <img
            src={PhoneDoodleMultiply}
            style={{
              position: "absolute",
              zIndex: 2,
              right: "3rem",
              top: "8rem",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <div
            className="d-flex justify-content-center"
            style={{
              position: "relative",
              marginTop: "20%",
              marginBottom: "10%",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                borderBottomRightRadius: "10px",
                height: "25rem",
                width: "90%",

                backgroundColor: "#F6EBDC",
                borderTopRightRadius: "50px",
                borderBottomLeftRadius: "50px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  minWidth: "100%",
                  marginTop: "45%",
                  marginBottom: "5%",
                }}
              >
                <div
                  style={{
                    fontSize: "4.2vw",
                    width: "80%",
                    margin: "0 auto",
                    marginTop: "2%",
                    textAlign: "center",
                    marginBottom: "15%",
                  }}
                >
                  Download the Kanha Home Tuitions Student and Tutor apps now on
                  Google Play Store!
                </div>
                <Grid
                  item
                  xs={10}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  xxl={3}
                  container
                  spacing={3}
                  sx={{ margin: "0 auto" }}
                >
                </Grid>
                <img
                  src={PhoneDoodleBook}
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    left: "4rem",
                    bottom: "2rem",
                  }}
                />
                <img
                  src={PhoneDoodleDivide}
                  style={{
                    position: "absolute",
                    zIndex: 2,
                    right: "3rem",
                    bottom: "1rem",
                  }}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <div style={{ 
  height: isXs ? '500px' : '700px', 
  padding: isXs ? '50px 60px' : '50px 10px', 
  backgroundColor: '#FFF7F3', 
  marginTop: '30px' 
}}>
  <ul style={{ 
    display: 'grid', 
    gridTemplateColumns: isXs ? 'repeat(3, 1fr)' : 'repeat(1, 1fr)', 
    gap: '10px', 
    padding: '10px', 
    fontSize: isXs ? '15px' : '12px',
    justifyContent: 'center', // Centers the grid items horizontally
    listStylePosition: 'inside', // Ensures bullets (if any) are aligned properly
  }}>
 <li>Best Mathematics Home Tuition in Lucknow</li>
  <li>Best Mathematic Tutor for Mathematics</li>
  <li>Mathematics Home Tuition in Gomti Nagar</li>
  <li>Mathematics Home Tuition in Alambagh</li>
  <li>Mathematics Home Tuition in Indira Nagar</li>
  <li>Mathematics Home Tuition in Hazratganj</li>
  <li>Mathematics Home Tuition in Mahanagar</li>
  <li>Mathematics Home Tuition in Rajajipuram</li>
  <li>Mathematics Home Tuition in Aliganj</li>
  <li>Mathematics Home Tuition in Jankipuram</li>
  <li>Mathematics Home Tuition in Vikas Nagar</li>
  <li>Mathematics Home Tuition in Aminabad</li>
  <li>Mathematics Home Tuition in Ashiyana</li>
  <li>Mathematics Home Tuition in Chowk</li>
  <li>Mathematics Home Tuition in Telibagh</li>
  <li>Mathematics Home Tuition in Faizabad Road</li>
  <li>Mathematics Home Tuition in Sitapur Road</li>
  <li>Mathematics Home Tuition in Cantt Road</li>
  <li>Mathematics Home Tuition in Krishna Nagar</li>
  <li>Mathematics Home Tuition in Charbagh</li>
  <li>Mathematics Home Tuition in Nirala Nagar</li>
  <li>Mathematics Home Tuition in Transport Nagar</li>
  </ul>
</div>
            <Dialog
              aria-labelledby="unstyled-modal-title"
              aria-describedby="unstyled-modal-description"
              onClose={handleClose("backdropClick")}
              open={open}
              sx={{ 
                overflow: isXs ? "" : "auto",
                "& .MuiDialog-paper": {
                  width: isXs ? '38%' : '600px', 
                  maxWidth: 'none',
                }
              }}
              
            >
              <div
                className="modal-content"
                style={{
                  marginTop: isXs ? "" : "0%",
                  textAlign: isXs ? "" : "center",
                  width: isXs ? "100%" : "100%",
                
                }}
              >
                <Button
                  style={{
                    position: "absolute",
                    right: "0%",
                    backgroundColor: "white",
                    borderRadius: "100%",
                    minWidth: "2rem",
                    color: "black",
                  }}
                  onClick={() => handleClose("close")}
                >
                  X
                </Button>
                <div
                  className="text-center py-2 fw-bold"
                  style={{
                    backgroundColor: "#CB8B65",
                    width: "100%",
                    fontSize: isXs ? "28px" : "22px",
                    marginBottom: "5%",
                    display: "flex",
                    justifyContent: "center",
                    gap: "0.5rem",
                  }}
                >
                  <div
                    style={{
                      color: "#FFDB7E",
                    }}
                  >
                    FREE
                  </div>
                  <div
                    style={{
                      color: "white",
                    }}
                  >
                    REGISTRATION
                  </div>
                </div>
                <form   onSubmit={handleSubmit(onSubmitHandler)}>
                  <Box
                    className="d-flex justify-content-center mt-2"
                    component="form"
                    sx={{
                      "& .MuiTextField-root": {
                        m: 1,
                        width: isXs ? "23ch" : "75%",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "0.5px",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <div style={{ textAlign: isXs ? "end" : "center" }}>
                          <TextField
                            {...register("fullName")}
                            name="fullName"
                            id="fullName"
                            label="Full Name"
                            type="text"
                            placeholder="Enter your Full Name"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setFullName(e.target.value)
                            // }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginRight: isXs ? "12%" : "",
                            }}
                          >
                            {errors.fullName?.message}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <div>
                          <TextField
                            {...register("mobileNumber")}
                            name="mobileNumber"
                            id="mobileNumber"
                            label="Mobile Number"
                            type="number"
                            placeholder="Enter your Mobile Number"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setMobileNumber(e.target.value)
                            // }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginLeft: isXs ? "5%" : "",
                            }}
                          >
                            {errors.mobileNumber?.message}
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    className="d-flex  mt-1 justify-content-between "
                    component="form"
                    sx={{
                      "& .MuiTextField-root": {
                        m: 1,
                        width: isXs ? "23ch" : "75%",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "0.5px",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <div style={{ textAlign: isXs ? "end" : "center" }}>
                          <TextField
                            {...register("email")}
                            name="email"
                            id="email"
                            label="Email"
                            type='"email'
                            placeholder="Enter your Email"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            style={{ marginLeft: "3%" }}
                            // onChange={(e) =>
                            //     setEmail(e.target.value)
                            // }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginRight: isXs ? "20%" : "",
                            }}
                          >
                            {errors.email?.message}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <FormControl
                          component="fieldset"
                          style={{ marginLeft: "4%" }}
                        >
                          <FormLabel
                            component="legend"
                            style={{
                              marginBottom: "0%",
                              fontSize: isXs ? "0.9vw" : "3vw",
                              color: "black",
                              letterSpacing: "0px",
                            }}
                          >
                            Mode of Classes*
                          </FormLabel>
                          <Controller
                            // rules={{ required: true }}
                            control={control}
                            name="classMode"
                            render={({ field }) => (
                              <RadioGroup
                                row
                                aria-label="position"
                                {...field}
                                name="position"
                              >
                                <FormControlLabel
                                  value="1"
                                  control={<Radio color="primary" />}
                                  label={
                                    <span
                                      style={{
                                        fontSize: isXs ? "1vw" : "3vw",
                                      }}
                                    >
                                      Online
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  value="0"
                                  control={<Radio color="primary" />}
                                  label={
                                    <span
                                      style={{
                                        fontSize: isXs ? "1vw" : "3vw",
                                      }}
                                    >
                                      Offine
                                    </span>
                                  }
                                />
                              </RadioGroup>
                            )}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    className="d-flex justify-content-center mt-1"
                    component="form"
                    sx={{
                      "& .MuiTextField-root": {
                        m: 1,
                        width: isXs ? "23ch" : "75%",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "0.5px",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <div style={{ textAlign: isXs ? "end" : "center" }}>
                          <TextField
                            name="ccb"
                            id="ccb"
                            label="Course / Class/ Board"
                            type='"text'
                            placeholder="Enter Course You Need"
                            {...register("course")}
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setCource(e.target.value)
                            // }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginRight: isXs ? "17%" : "",
                            }}
                          >
                            {errors.course?.message}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <div>
                          <TextField
                            name="subject"
                            {...register("subject")}
                            id="subject"
                            label="Subject"
                            type="text"
                            placeholder="Enter Subject You Need"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setSubject(e.target.value)
                            // }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginLeft: isXs ? "5%" : "",
                            }}
                          >
                            {errors.subject?.message}
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    className="d-flex justify-content-center mt-1"
                    component="form"
                    sx={{
                      "& .MuiTextField-root": {
                        m: 1,
                        width: isXs ? "13.8ch" : "75%",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderWidth: isXs ? "2px" : "2px",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Grid container>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                        <div style={{ textAlign: isXs ? "end" : "center" }}>
                          <TextField
                            {...register("city")}
                            name="city"
                            id="city"
                            label="City"
                            type='"text'
                            placeholder="Enter City Name"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setCity(e.target.value)
                            // }
                          />
                          <p style={{ fontSize: "12px", color: "red" }}>
                            {errors.city?.message}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                        <div style={{ textAlign: "center" }}>
                          <TextField
                            {...register("area")}
                            name="area"
                            id="area"
                            label="Area"
                            type="text"
                            placeholder="Enter Area Name"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setArea(e.target.value)
                            // }
                          />
                          <p style={{ fontSize: "12px", color: "red" }}>
                            {errors.area?.message}
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                        <div tyle={{ textAlign: "start" }}>
                          <TextField
                            {...register("pincode")}
                            name="pincode"
                            id="pincode"
                            label="Pincode"
                            type="text"
                            placeholder="Enter Pincode"
                            required
                            inputProps={{
                              style: {
                                height: "10px",
                                fontSize: "12px",
                              },
                            }}
                            InputLabelProps={{
                              sx: { color: "black" },
                            }}
                            color="grey"
                            focused
                            // onChange={(e) =>
                            //     setPincode(e.target.value)
                            // }
                          />
                          <p style={{ fontSize: "12px", color: "red" }}>
                            {errors.pincode?.message}
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                  <div className="d-flex justify-content-center my-2">
      
                    {loading ? (
                      <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                        <CircularProgress color="success" />
                      </Stack>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary py-2 w-75 fw-bold"
                        style={{
                          fontSize: "14px",
                          border: "1px solid #CB8B65",
                          backgroundColor: "#FFDB7E",
                          color: "#866D2C",
                          borderRadius: "0",
                        }}
                      >
                        Next
                      </button>
                    )}
                  </div>
                </form>
                <div
                  style={{
                    height: "40px",
                    textAlign: "center",
                    alignItems: "center",
                    padding: "10px 0px",
                  }}
                >
                  {" "}
                  <span style={{ fontWeight: "700", fontSize: "14px" }}>
                    Are you a Tutor?
                  </span>{" "}
                  <a href="/signup-teacher">
                    <span style={{ fontSize: "14px", fontWeight: "700" }}>
                      Create Free Profile
                    </span>
                  </a>
                </div>
      
                <div className="d-flex flex-row justify-content-between w-full mb-3">
                  <div
                    className="flex-grow-1 text-center"
                    style={{
                      fontSize: "12px",
                      fontWeight: "900",
                    }}
                  >
                    <small className="block">
                      <span className="">By signing up you agree to our </span>
                      <a href="/terms-conditions" style={{ color: "#0582D2" }}>
                        {" "}
                        Terms and Conditions
                      </a>
                    </small>
                  </div>
                </div>
              </div>
            </Dialog>
            <Dialog
              open={openOtpNew}
              onClose={() => {}}
              maxWidth="md"
              sx={{
                "& .MuiBackdrop-root": {
                  backdropFilter: "blur(1px)", // Apply blur effect directly
                },
              }}
              PaperProps={{
                sx: {
                  padding: "rem",
                  overflowX: "hidden",
                },
              }}
            >
              <Button
                onClick={handleCloseOtpNew}
                style={{
                  position: "absolute",
                  right: "0%",
                  top: "0",
                  backgroundColor: "white",
                  borderRadius: "100%",
                  minWidth: "2rem",
                  color: "black",
                  border: "1px solid black",
                }}
              >
                X
              </Button>
      
              <div style={{ padding: "1rem" }}>
                <form
                  onSubmit={handleSubmitOtpNew}
                  style={{ padding: isXs ? "0px 10px" : "0px 0px" }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ fontSize: "30px", textAlign: "center" }}>
                      OTP Verification{" "}
                    </div>
      
                    <div style={{ textAlign: "center" }}>
                      {" "}
                      A One-Time Password has been sent to{" "}
                      {studentQueryFormData
                        ? studentQueryFormData.get("mobile")
                        : null}
                    </div>
                    <div>
                      <MuiOtpInput
                        style={{
                          width: isXs ? "400px" : "270px",
                          gap: isXs ? "20px" : "5px",
                          padding: "14px 3px",
                          alignItems: "center",
                          textAlign: "center",
                          display: "flex",
                          margin: "0px auto",
                        }}
                        value={otpNew}
                        onChange={handleChangeOtpNew}
                        length={6}
                      />
                    </div>
      
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "20px",
                        gap: "10px",
                        flexDirection: isXs ? "" : "column",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>Didn’t Receive OTP?</div>
                      {loading2 ? (
                        <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                          <CircularProgress color="success" />
                        </Stack>
                      ) : (
                        <div
                          type="button"
                          style={{ color: "#cb8b65", textAlign: "center" }}
                          onClick={handleResendOtpNew}
                        >
                          Resend OTP
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "70px",
                    }}
                  >
                    {loading ? (
                      <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                        <CircularProgress color="success" />
                      </Stack>
                    ) : (
                      <button
                        style={{
                          backgroundColor: "#CB8B65",
                          color: "white",
                          width: "30rem",
                          height: "2.5rem",
                          border: "none",
                          borderRadius: "3px",
                        }}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </Dialog>
      <Footer />

    </>
  );
};
export default MathematicsHomeTuitionLucknow;